import { css, cx, etiColors } from '@eti/styles';
import { constants } from '@eti/utils';
import { Text, textVariants } from '@etg/wings';
import Icon from '../icon/Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  ADULT,
  CHILD,
  INFANT
} = constants.ageTypes;
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const travelerDescriptionStyles = css`
  align-items: center;
  color: ${etiColors.black};
  display: flex;
`;
const getClassNames = className => cx('etiTravelerDescription', travelerDescriptionStyles, className);
const getIconId = type => {
  switch (type) {
    case CHILD:
      return 'child-traveler';
    case INFANT:
      return 'infant-traveler';
    case ADULT:
    default:
      return 'adult-traveler';
  }
};
const nameStyles = css`
  margin-right: 5px;
`;
const iconWrapperStyles = css`
  line-height: 0;
`;
const iconStyles = css`
  fill: ${etiColors.black};
  height: 1rem;
  margin-right: 0.625rem;
  width: 1rem;

  [dir='rtl'] & {
    margin-left: 0.625rem;
    margin-right: 0;
  }
`;
const TravelerDescription = _ref => {
  let {
    className = '',
    description,
    name,
    shouldShowIcon,
    type = ADULT
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: getClassNames(className),
    children: [shouldShowIcon && type && /*#__PURE__*/_jsx("div", {
      className: iconWrapperStyles,
      children: /*#__PURE__*/_jsx(Icon, {
        className: cx(iconStyles),
        id: getIconId(type)
      })
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Text, {
        className: cx(nameStyles, MOUSE_FLOW_CLASS_NAMES),
        variant: textVariants._14_BOLD,
        children: name
      }), /*#__PURE__*/_jsx(Text, {
        children: description
      })]
    })]
  });
};
export default TravelerDescription;
//# sourceMappingURL=TravelerDescription.js.map